function getTag(anchor) {
    let anchorName = anchor.replace('#', '').replace('/', '');
    let findTag = document.querySelector('a[name=' + anchorName + ']');
    if (findTag == null) {
        findTag = document.getElementById(anchorName);
    }
    return findTag;
}

function moveToAnchor(findTag, offset) {
    if (findTag != null) {
        let scrollOfset = findTag.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({
            top: scrollOfset,
            behavior: 'smooth'
        });
    }
}

document.addEventListener("DOMContentLoaded", function (event) {
    const offset = 0;

    document.querySelectorAll('a[href*="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            let tag = getTag(this.getAttribute('href'));
            if (tag != null) {
                e.preventDefault();
                moveToAnchor(tag, offset)
            }
        });
    });

    if (window.location.hash) {
        let tag = getTag(window.location.hash);
        if (tag != null) {
            moveToAnchor(tag, offset)
        }
    }
});
